import React, { useEffect, useState } from "react";
import Headertwo from "./Headertwo";
import imageCopy from "../../assets/images/sdssss.png";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import imageOne from "../../assets/images/img1.png";
import imagetwo from "../../assets/images/img2.png";
import imgthird from "../../assets/images/img3.png";
import icon1 from "../../assets/images/icon1.png";
import icon2 from "../../assets/images/icon2.png";
import icon3 from "../../assets/images/icon3.png";
import Footertwo from "./Footertwo";
import { useNavigate } from "react-router-dom";
import {
  GetToken,
  canPurchaseSubscription,
  pickCurrentSubscription,
} from "../../utils/helper/helper";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  CreatePymenentUrlFn,
  ManagerGetById,
  PlayerGetById,
  RedeemPromoCode,
  GetSubScription,
} from "../../redux/auth-reducer/auth-service";
import { Alert, Container, Form, InputGroup, Modal, Row } from "react-bootstrap";
import {
  CHECKOUT_OUTCOME,
  saveCheckoutIntent,
  startCheckout,
} from "../../utils/helper/checkout";
import { toast } from "react-toastify";
import AppleStore from '../../assets/images/appStore.png'
import AndroidStore from '../../assets/images/google-play.jpg'
import { SignUpChoiceModal } from './SignUpChoiceModal';

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 6,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1199 },
    items: 6,
  },
  desktop1: {
    breakpoint: { max: 1200, min: 1023 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const Home = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState();
  const [selectedOption, setSelectedOption] = useState("");
  const [userDataItem, setUserDataItem] = useState();
  const [smShow, setSmShow] = useState(false);
  const handleClose = () => setSmShow(false);
  const handleShow = () => setSmShow(true);
  const [promoCode, setPromoCode] = useState("");
  const [showcodeModel, setShowcodeModel] = useState(false);
  const [validated, setValidated] = useState(false);
  // #288: what the Promo Code dialog says instead of redirecting (needs an account) or a toast (refused).
  const [promoNeedsAccount, setPromoNeedsAccount] = useState(false);
  const [promoError, setPromoError] = useState("");
  const [dataSubscription, setDataSubscription] = useState(null);
  const [isLoadingSub, setIsLoadingSub] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [blockedMessage, setBlockedMessage] = useState("");
  const [checkoutBusy, setCheckoutBusy] = useState(false);
  /** {message, sessionUrl} - the inline state shown under the plan buttons. */
  const [checkoutState, setCheckoutState] = useState(null);
  const handleCodeModelShow = () => setShowcodeModel(true);

  const handlecodeModelClose = () => {
    setShowcodeModel(false);
    setPromoCode("");
    setValidated(false);
    setPromoNeedsAccount(false);
    setPromoError("");
  };

  const redeemPromoCode = (event) => {
    event.preventDefault();
    setValidated(true);
    setPromoNeedsAccount(false);
    setPromoError("");
    // #288: an empty code used to send a signed-out user to registration with no message at all.
    if (!promoCode.trim()) return;
    let token = GetToken();
    if (token == null) {
      // The redeem call needs a signed-in user; say so here rather than redirecting silently.
      setPromoNeedsAccount(true);
    } else {
      const GetCode = async () => {
        await RedeemPromoCode(promoCode.trim()).then((res) => {
          if (res?.data?.status === true) {
            setValidated(false);
            toast.success(res?.data?.message);
            handlecodeModelClose();
            setPromoCode("");
            // The grant this just created is what the page decides the subscribe call-to-action
            // from, so without re-reading it a player who has only now redeemed is still being
            // told to subscribe until they reload. Account_settings.js already does this.
            fetchSubscription();
          } else {
            setPromoError(res?.data?.message || "This promo code can't be redeemed.");
            setValidated(false);
          }
        }).catch((error) => {
          setPromoError(
            error?.response?.data?.message || "Something went wrong. Please try again."
          );
          setValidated(false);
        });
      };
      GetCode();
    }
  };

  const fetchSubscription = async () => {
    try {
      setIsLoadingSub(true);
      const res = await GetSubScription();
      const list = res?.data?.data || [];
      setDataSubscription(pickCurrentSubscription(list));
    } catch (err) {
      console.error(err);
      setDataSubscription(null);
    } finally {
      setIsLoadingSub(false);
    }
  };

  useEffect(() => {
    fetchSubscription();
  }, []);

  const handlePromoCode = (e) => {
    // #288: was `setPromoCode(([e.target.name] = e.target.value))`, a destructuring assignment
    // that also renamed the input to the first character typed.
    setPromoCode(e.target.value);
    setPromoNeedsAccount(false);
    setPromoError("");
  };
  const Role = localStorage.getItem("role");

  // dataSubscription was already being fetched here and then never read. It answers whether a
  // purchase would be refused, so the plan block below can say so instead of sending the user to
  // the server for a rejection. It is undefined for a logged-out visitor, and the helper treats
  // that as purchasable, which is what the marketing view needs.
  const canPurchase = canPurchaseSubscription(dataSubscription);

  const handelSubmit = async (event) => {
    navigate("/Login");
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const proceedWithPayment = async () => {
    setCheckoutState(null);
    setCheckoutBusy(true);

    const result = await startCheckout(() => CreatePymenentUrlFn(selectedOption));

    if (result.outcome === CHECKOUT_OUTCOME.REDIRECTING) {
      // This tab is leaving for Stripe: stay disabled, and leave a link behind in case it does
      // not, so the user is never looking at a screen with nothing to click.
      setCheckoutState({ message: "", sessionUrl: result.sessionUrl });
      return;
    }

    setCheckoutBusy(false);

    // The server owns the "no plan switching mid-period" rule and its wording, including the
    // date the current subscription ends.
    if (result.outcome === CHECKOUT_OUTCOME.REFUSED) {
      setBlockedMessage(result.message);
      setShowConfirmModal(true);
      return;
    }

    setCheckoutState({ message: result.message, sessionUrl: null });
  };

  const handelSubmitPlayer = async (event) => {
    event.preventDefault();
    const token = GetToken();
    if (!token) {
      saveCheckoutIntent(selectedOption);
      return navigate("/Login");
    }

    // No remaining-days pre-check: the server is the single enforcement point.
    await proceedWithPayment();
  };

  /**
   * The inline outcome of the last payment attempt.
   *
   * Built once and rendered in both plan cards below - the signed-in Player branch and the
   * signed-out one are two separate copies of the same markup.
   */
  const checkoutStatus = (
    <>
      {checkoutBusy && !checkoutState?.sessionUrl && (
        <p className="mt-2 mb-0">Opening secure checkout...</p>
      )}
      {checkoutState?.message && (
        <Alert variant="warning" className="mt-3 mb-0 text-start">
          {checkoutState.message}{" "}
          <Alert.Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              proceedWithPayment();
            }}
          >
            Try again
          </Alert.Link>
        </Alert>
      )}
      {checkoutState?.sessionUrl && (
        <Alert variant="info" className="mt-3 mb-0 text-start">
          If the payment page did not open,{" "}
          <Alert.Link href={checkoutState.sessionUrl} rel="noopener noreferrer">
            open it here
          </Alert.Link>
          .
        </Alert>
      )}
    </>
  );

  useEffect(() => {
    async function ManagerGet() {
      const isUser = JSON.parse(localStorage.getItem("isUser"));
      const userId = isUser?.userId;
      if (userId) {
        await ManagerGetById(userId).then((res) => {
          setUserData(res?.data);
        });
      }
    }
    ManagerGet();
  }, []);

  useEffect(() => {
    const UserGet = async () => {
      const isUser = JSON.parse(localStorage.getItem("isUser"));
      const userId = isUser?.userId;
      if (userId) {
        await PlayerGetById(userId).then((res) => {
          setUserDataItem(res?.data);
        });
      }
    };
    UserGet();
  }, []);

  const handleScroll = () => {
    const section = document.getElementById("mySection");
    section.scrollIntoView({ behavior: "smooth" });
  };

  const isUserExists = localStorage.getItem("role");
  return (
    <>
      <Headertwo />

      <Modal
        show={showcodeModel}
        onHide={handlecodeModelClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Form noValidate validated={validated} onSubmit={redeemPromoCode}>
          <Modal.Header
            closeButton
            className="promo-code-header className promo-close"
          >
            <Modal.Title>Redeem Promo Code</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Col} md="12" controlId="validationCustomFristname">
              <InputGroup hasValidation>
                <Form.Control
                  type="text"
                  name="promoCode"
                  value={promoCode}
                  onChange={handlePromoCode}
                  placeholder="Enter promo code"
                  aria-describedby="inputGroupPrepend"
                  required
                  // #288: spaces only pass `required`, but are no code either
                  isInvalid={validated && !promoCode.trim()}
                />

                <Form.Control.Feedback type="invalid">
                  Please enter a promo code.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            {promoNeedsAccount && (
              <Alert variant="info" className="mt-3 mb-0">
                Please register or log in to redeem your promo code.
                <div className="d-flex gap-2 mt-2">
                  <Button size="sm" variant="primary" onClick={() => navigate("/UserRegistration")}>
                    Register
                  </Button>
                  <Button size="sm" variant="outline-primary" onClick={() => navigate("/Login")}>
                    Log in
                  </Button>
                </div>
              </Alert>
            )}
            {promoError && (
              <Alert variant="danger" className="mt-3 mb-0" role="alert">
                {promoError}
              </Alert>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handlecodeModelClose}>
              Close
            </Button>
            <Button type="submit" variant="primary">
              Redeem now
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <section className="banner">
        <div className="container-fluid">
          <div className="row">
            <Col>
              <div class="p-2 text-white text-left text-area">
                <h1 className="heading">
                  The Ultimate<br></br>
                  Sports Auction <br></br>Software
                </h1>

                <p className="paragraph mb-3 mt-3">
                  Create a powerful customized online sports auction to compete
                  against your chosen competitors
                </p>
                <Button
                  variant="outline-success1"
                  className="btnone"
                  onClick={handleScroll}
                >
                  Get Started{" "}
                </Button>
                {!isUserExists && (
                  <Button
                    variant="primary"
                    className="btntwo"
                    onClick={handleShow}
                  >
                    Join Now
                  </Button>
                )}
              </div>
            </Col>

            <img src={imageCopy} className="image_one" />
          </div>
        </div>
      </section>
      <SignUpChoiceModal show={smShow} onHide={handleClose} />
      <section className="padding">
        <div style={{marginTop:'-220px', paddingLeft:'40px' }}>
    <a href="https://apps.apple.com/us/app/xcutta/id6748455188" target="_blank" aria-label="Download on the App Store" >
      <img src={AppleStore} alt="Download on the App Store" width="160" />
    </a>
    <a href="https://play.google.com/store/apps/details?id=com.companyname.gadienterprisesgamc" target="_blank" aria-label="Get it on Google Play">
      <img src={AndroidStore} alt="Get it on Google Play" width="190" />
    </a>
  </div>
        <div class="container">
          <div className="row">
            <div className="col postion">
              <div class="second card cardone">
                <img src={imageOne} className="image-card" height={346} />
                <div class="title">
                  <h1>eBidding software </h1>
                  <h1>built for your needs</h1>
                </div>
              </div>
            </div>
            <div className="col">
              <div class="second card cardtwo">
                <img src={imagetwo} className="image-card" height={346} />
                <h1 className="headingcenter">
                  More than 1000 teams and players<br></br> available in data
                  base
                </h1>
              </div>
            </div>
            <div className="col postion">
              <div class="second card thirdcard">
                <img src={imgthird} className="image-card" height={346} />
                <div class="thirdimg">
                  <h1>Customize your auction and winnings</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row text-center">
            <p className="paragraphtext">
              Create your digital sports auction contest and invite competitors
              from around the world.
            </p>
          </div>
        </div>
      </section>

      <section className="section-auction padding2">
        <div class="container">
          <div className="row text-center">
            <h1 className="pt-5">Streamline Your Auction Process</h1>

            <div className="col-sm-4">
              <div class="second card padding-section section-text-area">
                <div class="title2 text-center">
                  <img src={icon1} className="iconss" />
                  <h1 className="pt-4 pb-4">Get Started Instantly</h1>
                  <h2>
                    Register for Free as a Xcutta Manager and explore all the
                    possibilities.
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div class="second card padding-section section-text-area">
                <div class="title2 text-center">
                  <img src={icon2} className="iconss" />
                  <h1 className="pt-4 pb-4">Take Control of Your Data</h1>
                  <h2>
                    Oversee all your data—from users to bids, and more—and
                    utilize web analytics to understand which of your activities
                    drive bids.
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div class="second card padding-section section-text-area">
                <div class="title2 text-center">
                  <img src={icon3} className="iconss" />
                  <h1 className="pt-4 pb-4">Access From Anywhere</h1>
                  <h2>
                    Customize your Xcutta Player List by recruiting competitors
                    from around the world.
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h1 className="auction-img">Play Xcutta</h1>
      </section>
      {Role == "Web Admin" ? (
        ""
      ) : Role == "Manager" ? (
        <section className="section-auction padding2 bg-img">
          <div class="container" id="mySection">
            <div className="row text-center">
              <h1 className="pt-5 text-white">Register Now to Play</h1>
              <div className="col">
                <div class="second card padding-section subscrption-card">
                  <div class="title2 text-center">
                    <h1 className=" pb-4 title-text">Xcutta Manager</h1>
                    <h2 className="pb-2">
                      Register for free to create your own customized Sports
                      Auctions.
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : Role == "Player" ? (
        <section className="section-auction padding2 bg-img">
          <div class="container" id="mySection">
            <div className="row text-center">
              <h1 className="pt-5 text-white">Register Now to Play</h1>

              <div className="col">
                <div class="second card padding-section subscrption-card">
                  <div class="title2 text-center">
                    <h1 className=" pb-4 title-text">Xcutta Player</h1>
                    <h2 className="pb-2">
                      Register to play as a Xcutta Player for any Auction or
                      Contest.
                    </h2>

                    {/* A signed-in Player who already has a live subscription cannot buy another,
                        so offering the picker here only sends them to a rejection. The guest
                        branch further down keeps its picker: a logged-out visitor has no
                        subscription state and that block is the marketing view. */}
                    {isLoadingSub ? null : canPurchase ? (
                      <>
                        <form>
                          <label className="w-100 group-input-feild">
                            <input
                              type="radio"
                              name="plan"
                              value="1"
                              checked={selectedOption === "1"}
                              class="input-radio-button"
                              onChange={handleOptionChange}
                            />
                            <span class="price-value">$4.99 / Month</span>
                          </label>
                          <p className="or">Or</p>
                          <label className="w-100 group-input-feild">
                            <input
                              type="radio"
                              name="plan"
                              value="2"
                              class="input-radio-button"
                              checked={selectedOption === "2"}
                              onChange={handleOptionChange}
                            />
                            <span class="price-value">$49.99 / Year</span>
                          </label>
                          <br />
                        </form>
                        <Row>
                          <Col md={12} className="mb-2">
                            <Button
                              type="submit"
                              disabled={!selectedOption || checkoutBusy}
                              onClick={handelSubmitPlayer}
                              className="btn-outline-success-three"
                            >
                              Click for Subscription
                            </Button>
                            <button
                              className="bg-promocode-btn btn btn-primary"
                              onClick={handleCodeModelShow}
                            >
                              Promo Code
                            </button>
                          </Col>
                        </Row>
                        {checkoutStatus}
                      </>
                    ) : (
                      <Row>
                        <Col md={12} className="mb-2">
                          <p className="pb-2">
                            {dataSubscription?.purchaseBlockedMessage ||
                              "You already have an active subscription."}
                          </p>
                          <Button
                            onClick={() => navigate("/Player/Account_settings")}
                            className="btn-outline-success-three"
                          >
                            Manage subscription
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section className="section-auction padding2 bg-img">
          <div class="container" id="mySection">
            <div className="row text-center">
              <h1 className="pt-5 text-white">Register Now to Play</h1>
              <div className="col">
                <div class="second card padding-section subscrption-card">
                  <div class="title2 text-center">
                    <h1 className="pb-4 title-text">Xcutta Manager</h1>
                    <h2 className="pb-2">
                      Register for free to create your own customized Sports
                      Auctions.
                    </h2>
                    <form onSubmit={handelSubmit}>
                      <Button
                        type="submit"
                        className="btn-outline-success-three"
                      >
                        Click Here
                      </Button>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col">
                <div class="second card padding-section subscrption-card">
                  <div class="title2 text-center">
                    <h1 className="pb-4 title-text">Xcutta Player</h1>
                    <h2 className="pb-2">
                      Register to play as a Xcutta Player for any Auction or
                      Contest.
                    </h2>

                    <form>
                      <label className="w-100 group-input-feild">
                        <input
                          type="radio"
                          value="1"
                          checked={selectedOption === "1"}
                          class="input-radio-button"
                          onChange={handleOptionChange}
                        />
                        <span class="price-value">$4.99 / Month</span>
                      </label>
                      <p className="or">Or</p>
                      <label className="w-100 group-input-feild">
                        <input
                          type="radio"
                          value="2"
                          class="input-radio-button"
                          checked={selectedOption === "2"}
                          onChange={handleOptionChange}
                        />
                        <span class="price-value">$49.99 / Year</span>
                      </label>
                    </form>
                    <br></br>
                    <Row>
                      <Col md={12} className="mb-2">
                        <Button
                          type="submit"
                          disabled={!selectedOption || checkoutBusy}
                          onClick={handelSubmitPlayer}
                          className="btn-outline-success-three"
                        >
                          Click Here{" "}
                        </Button>
                        <button
                          className="bg-promocode-btn btn btn-primary"
                          onClick={handleCodeModelShow}
                        >
                          Promo Code
                        </button>
                      </Col>
                    </Row>
                    {checkoutStatus}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <section className="section-auction-sport">
        <Container>
          <h1 className="text-center mt-5 mb-5">
            Customize your Sports Auction Contest
          </h1>
          <Carousel
            responsive={responsive}
            autoPlay={true}
            autoPlaySpeed={3000}
            infinite={true}
            arrows={true}
          >
            <div className="item-slider">
              <img src="../image/sport/CFL.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/Champions Tour.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/College Sports.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/COPA America.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/English FA Cup.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/Formula 1 Racing.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/Golf.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/LALIGA Soccer.png"></img>
            </div>

            <div className="item-slider">
              <img src="../image/sport/LPGA.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/Masters.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/Men's Tennis.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/MLB.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/MLS.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/Nascar.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/NBA.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/NFL.png"></img>
            </div>

            <div className="item-slider">
              <img src="../image/sport/la-liga.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/PGA-Tour.png"></img>
            </div>

            <div className="item-slider">
              <img src="../image/sport/NHL.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/Premier League.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/Testing July 29.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/UEFA Champions League Soccer.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/WNBA.png"></img>
            </div>
            <div className="item-slider">
              <img src="../image/sport/Women's Tennis.png"></img>
            </div>
          </Carousel>
        </Container>
      </section>

      <section className="section-auction padding2 registration-sec">
        <div className="container">
          <div className="row text-center">
            <h1 className="pt-5">Powerful Data Collection and Analytics</h1>
            <p class="paragraphtext mb-5">
              The Thrill of Live Auctions with Sports Prognostication
            </p>
            <div className="col mt-5">
              <div className="second card padding-section free-subscription">
                <div className="title2 text-left">
                  <h1 className="pt-4 pb-4 text-regiter">
                    Register for Free as Xcutta Manager <br></br>
                    <span>
                      <b>or</b>
                    </span>
                    <br />
                    Subscribe as a Xcutta Player
                  </h1>
                  <h2>
                    Gain a comprehensive view of bidding trends, value analytics
                    and Sports Auction history.
                  </h2>

                  <Button
                    className="btn-outline-success-three mt-3"
                    onClick={handleScroll}
                  >
                    Get Started
                  </Button>
                </div>
              </div>
            </div>
            <div className="col mt-5">
              <div class="card">
                <img src="../image/registration.jpg" className="regid" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* States the no-plan-switching rule, using the server's wording. This modal used to
          offer a "Yes, Proceed" button that stacked another period on top. */}
      <Modal
        show={showConfirmModal}
        centered
        onHide={() => setShowConfirmModal(false)}
      >
        <Modal.Header
          closeButton
          className="promo-code-header className promo-close"
        >
          <Modal.Title>
            <b>Plan change unavailable</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{blockedMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Footertwo />
    </>
  );
};
